<template>
  <div>
    <VCupertino
      v-if="isShowModal"
      id="dialog-create-question"
      :is-show="isShowModal"
      :drawer-options="{
        modal:$viewport.isGreaterOrEquals('md'),
        cssClass:'dialog-create-question cupertino-modal'
      }"

      @backdropTap="closeCreateQuestion"
      @didDismiss="closeCreateQuestion"
    >
      <div class="dialog-create-question">
        <div class="dialog-create-question__body">
          <div class="dialog-create-question__title h2">{{ popupTitle }}</div>
          <div class="dialog-create-question__divider --hide-mobile" />
          <div class="product-card-question">
            <div class="product-card-question__image">
              <nuxt-img
                :src="String(product?.imageId)"
                width="160"
                height="160"
                fit="default"
                :modifiers="{'border': 'default'}"
                :alt="`product-${product?.name}-card-question-image-${product?.imageId}`"
              />
            </div>
            <div class="product-card-question__content">
              <div class="product-card-question__name h4">
                {{ product?.name }}
              </div>
              <div class="product-card-question__info">
                <div class="--rating">
                  <img
                    src="~/assets/img/svg/common/rating.svg"
                    alt="рейтинг"
                  />
                  {{ reviewRating }}
                </div>
                <div class="--quest">
                  {{ reviewCount }}
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-create-question__divider" />
          <div class="form-question">
            <div class="form-question__rating">
              <div class="--label h4">Задайте Ваш вопрос:</div>
              <div class="--grade">
                <div
                  v-for="(rating) in [1,2,3,4,5]"
                  :key="`rating-${rating}`"
                  :class="{'selected': rating <= formQuestion.rating}"
                  @click="() => changeFormReview('rating', rating)"
                />
              </div>
            </div>
            <div class="form-question__comment">
              <textarea
                v-model="formQuestion.message"
                class="textarea"
                placeholder="Поделитесь впечатлениями о товаре *"
              />
              <div
                v-for="(error, index) in $v.message.$errors"
                :key="index"
                class="error-valid"
              >
                {{ error.$message }}
              </div>
            </div>
            <div class="form-question__images">
              <div class="--label h4">Добавьте фотографии</div>
              <div class="--items">
                <div
                  v-for="(image, index) in formQuestion.images"
                  class="--image"
                >
                  <img
                    :src="_URL.createObjectURL(image)"
                    :alt="`фото с отзывом № ${index}`"
                  />
                  <div
                    class="--remove"
                    @click="() => removeImageFromForm(index)"
                  />
                </div>
                <label class="--icon">
                  <img
                    src="~/assets/img/svg/common/image.svg"
                    alt="изображение"
                  />
                  <input
                    type="file"
                    accept="image/jpeg,image/png"
                    hidden
                    multiple
                    @change="uploadFormImages"
                  />
                </label>
                <div
                  v-if="formQuestion.images.length <= 0"
                  class="--message h5"
                >
                  Нажмите и загрузите до 10 изображений в PNG, JPEG
                </div>
              </div>
            </div>
            <div class="form-question__images">
              <div class="--label h4">Добавьте видео</div>
              <div class="--items">
                <div
                  v-for="(image, index) in formQuestion.video"
                  class="--image"
                >
                  <video>
                    <source
                      :src="_URL.createObjectURL(image)"
                      type="video/mp4"
                    />
                  </video>
                  <div
                    class="--remove"
                    @click="() => removeVideoFromForm(index)"
                  />
                </div>
                <label class="--icon">
                  <img
                    src="~/assets/img/svg/common/video.svg"
                    alt="видео"
                  />
                  <input
                    type="file"
                    accept="video/*"
                    hidden
                    multiple
                    @change="uploadFormVideo"
                  />
                </label>
                <div
                  v-if="formQuestion.video.length <= 0"
                  class="--message h5"
                >
                  Нажмите и загрузите до 3 видео длительностью не более 5 минут
                </div>
              </div>
            </div>
            <div class="form-question__input">
              <input
                v-model="formQuestion.name"
                type="text"
                class="input"
                placeholder="Ваше имя *"
              />
              <div
                v-for="(error, index) in $v.name.$errors"
                :key="index"
                class="error-valid"
              >
                {{ error.$message }}
              </div>
            </div>
            <div class="form-question__input">
              <input
                v-model="formQuestion.email"
                type="text"
                class="input"
                placeholder="Ваш Email адрес *"
              />
              <div
                v-for="(error, index) in $v.email.$errors"
                :key="index"
                class="error-valid"
              >
                {{ error.$message }}
              </div>
            </div>
            <template v-if="isUserAdmin">
              <div class="form-question__input">
                <input
                  v-model="formQuestion.source"
                  type="text"
                  class="input"
                  placeholder="Источник (ЯндексКарты, 2GIS)"
                />
                <div v-if="false">
                  <div
                    v-for="(error, index) in $v.source.$errors"
                    v-if="$v.source"
                    :key="index"
                    class="error-valid"
                  >
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="form-question__input">
                <input
                  v-model="formQuestion.source_url"
                  type="text"
                  class="input"
                  placeholder="Источник (Ссылка)"
                />

                <div v-if="false">
                  <div
                    v-for="(error, index) in $v.source_url.$errors"
                    v-if="$v.source_url"
                    :key="index"
                    class="error-valid"
                  >
                    {{ error.$message }}
                  </div>
                </div>

              </div>
            </template>
            <div class="form-question__button">
              <button
                class="btn btn-primary"
                :disabled="!isAccept"
                @click="submitReviewForm"
              >
                Отправить вопрос
              </button>

              <div class="form-question__button_agreement">
                <agreement-with-policy
                  v-model="isAccept"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </VCupertino>
  </div>
</template>

<script setup lang="ts">
import { useCreateQuestionModal } from '~/composables/useCreateQuestionModal';
import {computed, type Ref, ref} from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { email, helpers, required } from '@vuelidate/validators';
import { useCommonStore } from '~/store/common';
import { useNotificationModal } from '~/composables/useNotificationModal';
import AgreementWithPolicy from "~/components/widget/AgreementWithPolicy.vue";

const $viewport = useViewport();
const VCupertino = defineAsyncComponent(() => import('~/components/widget/VCupertino.vue'));
const isShowModal = ref<boolean>(false);
const {
  product,

  closeCreateQuestionModal
} = useCreateQuestionModal();

const {
  changeLoading
} = useCommonStore();
const {
  openNotificationModal
} = useNotificationModal();

const {
  $api,
  $toast,

  $caseWords,
  $numberFormat
} = useNuxtApp();
const {
  userManagerInfo
} = useSitisUserManager();
const _URL: any = window.URL;

const popupTitle = computed<string>(() => {
  return product?.value?.isProductSet ? 'Ваш вопрос о коллекции' : 'Ваш вопрос о товаре';
})

const isUseClassesModal = computed(() => Boolean($viewport.isGreaterOrEquals('lg')));
const isUserAdmin = computed(() => {
  return Boolean(userManagerInfo.value?.id);
});

const reviewCount = computed(() => {
  const count = (product.value?.reviewsCount || 0);
  const word = $caseWords(count, ['отзыв', 'отзыва', 'отзывов']);
  return [count, word].join(' ');
});
const reviewRating = computed(() => $numberFormat((product.value?.reviewsCount || 0), 1, '.'));

// Логика заполенения формы
const validationForm = computed(() => {
  if (isUserAdmin.value) {
    return {
      name: {
        required: helpers.withMessage('Обязательно к заполнению', required)
      },
      email: {
        email: helpers.withMessage('Неверный формат', email),
        required: helpers.withMessage('Обязательно к заполнению', required)
      },
      message: {
        required: helpers.withMessage('Обязательно к заполнению', required)
      },

      // source: {
      //   required: helpers.withMessage('Обязательно к заполнению', required)
      // },
      // source_url: {
      //   required: helpers.withMessage('Обязательно к заполнению', required)
      // }
    };
  }
  return {
    name: {
      required: helpers.withMessage('Обязательно к заполнению', required)
    },
    email: {
      email: helpers.withMessage('Неверный формат', email),
      required: helpers.withMessage('Обязательно к заполнению', required)
    },
    message: {
      required: helpers.withMessage('Обязательно к заполнению', required)
    }
  };
});
const formQuestion: any = ref({
  type: 'question',
  name: '',
  email: '',
  rating: 0,
  message: '',
  source: '',
  source_url: '',
  video: [],
  images: [],
});
const $v = useVuelidate(validationForm, formQuestion);
const initForm = () => {
  if (!isUserAdmin.value) {
    return;
  }
  formQuestion.value.email = 'content@mia-sofia.ru';
};
const changeFormReview = (name: string, value: any) => {
  formQuestion.value[name] = value;
};
const uploadFormImages = (event: any) => {
  const images = [...(event?.target?.files || [])];
  formQuestion.value.images = [...formQuestion.value.images, ...images];
  event.target.value = null;
};
const removeImageFromForm = (index: number) => {
  const images = [...formQuestion.value.images];
  images.splice(index, 1);
  formQuestion.value.images = images;
};
const uploadFormVideo = (event: any) => {
  const video = [...(event?.target?.files || [])];
  formQuestion.value.video = [...formQuestion.value.video, ...video];
  event.target.value = null;
};
const removeVideoFromForm = (index: number) => {
  const video = [...formQuestion.value.video];
  video.splice(index, 1);
  formQuestion.value.video = video;
};
const submitReviewForm = async () => {
  const isFormCorrect = await $v.value.$validate();
  if (!isFormCorrect || !isAccept.value) {
    return false;
  }

  changeLoading(true);

  const formData: any = new FormData();
  formData.append('type', 'question');
  formData.append('name', formQuestion.value.name);
  formData.append('email', formQuestion.value.email);
  formData.append('text', formQuestion.value.message);
  formData.append('entities[0][model]', 'Product');
  formData.append('entities[0][model_key]', product.value?.id);

  (formQuestion.value.video || []).map((file: any) => {
    formData.append('attachments[]', file);
  });
  (formQuestion.value.images || []).map((file: any) => {
    formData.append('attachments[]', file);
  });
  if (formQuestion.value.rating > 0) {
    formData.append('rating', formQuestion.value.rating);
  }

  if (formQuestion.value.source) {
    formData.append('source', formQuestion.value.source);
  }
  if (formQuestion.value.source_url) {
    formData.append('source_url', formQuestion.value.source_url);
  }

  const res = await $api.agent.post('/reviews', {
    body: formData
  }).then((res) => res?._data).catch((err) => ({ error: err.response }));
  if (res?.error) {
    changeLoading(false);
    const errorMessage = (res?.error?._data || []).map((t: any) => t.message).join('.<br/>');
    $toast.error(errorMessage || 'Ошибка сервера');
    return;
  }
  changeLoading(false);
  closeCreateQuestion();
  openNotificationModal({
    title: 'Спасибо за вопрос!',
    message: 'Совсем скоро мы ответим на него и опубликуем на странице товара'
  });
};

// Закрытие формы
const closeCreateQuestion = () => {
  closeCreateQuestionModal();
};

const isAccept: Ref<boolean> = ref(true);

onMounted(() => {
  initForm();
  isShowModal.value = true;
});
</script>

<style lang="scss">
.dialog-create-question {
  .pane {
    max-width: 549px;
    overflow-x: hidden;
    padding-right: 7px;
  }
}

.dialog-create-question__body {
  padding: 41px;
}

.dialog-create-question__divider {
  margin: 31px 0;
  width: 100%;
  height: 1px;
  background-color: #F4F3F1;
}

.product-card-question {
  display: flex;
}

.product-card-question__image {
  width: 100%;
  max-width: 100px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background-color: #F4F3F1;
  margin-right: 24px;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    mix-blend-mode: multiply;
  }

  &:after {
    content: "";
    float: left;
    padding-top: 100%;
  }
}

.product-card-question__content {
  display: flex;
  flex-direction: column;
  padding: 6px 0;
  box-sizing: border-box;
  flex: 1;
  overflow: hidden;
}

.product-card-question__name {
}

.product-card-question__info {
  display: flex;
  align-items: center;
  margin-top: auto;

  color: #989898;
  font-size: 12px;
  font-weight: 500;
  line-height: 120%;

  .--rating {
    display: flex;
    align-items: center;
  }

  .--rating img {
    width: 12px;
    height: 16px;
    object-fit: contain;
    margin-right: 6px;
  }

  .--quest {
    margin-left: 14px;
    text-decoration: underline;
  }
}

.form-question {
}

.form-review__question {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .--label {
    color: black;
  }

  .--grade {
    display: flex;
    align-items: center;

    & > * {
      margin-left: 10px;
      width: 28px;
      height: 28px;
      cursor: pointer;
      background-image: url("@/assets/img/svg/common/star-empty.svg");

      &:hover {
        transform: scale(1.1);
      }

      &:first-child {
        margin-left: 0;
      }

      @for $i from 1 through 5 {
        &:nth-child(#{$i}) {
          &.selected {
            background-image: url("@/assets/img/svg/common/star.svg");
          }
        }
      }
    }
  }
}

.form-question__comment {
  margin-top: 40px;
}

.form-question__images {
  margin-top: 32px;

  .--label {
    color: black;
    margin-bottom: 16px;
  }

  .--items {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    margin-top: -16px;
    margin-left: -16px;

    & > * {
      margin-top: 16px;
      margin-left: 16px;
    }
  }

  .--icon, .--image {
    width: calc(100% / 4 - 16px);
    max-width: 100px;
    position: relative;
    border-radius: 16px;
    overflow: hidden;

    img, video {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &:after {
      content: "";
      float: left;
      padding-top: 100%;
    }
  }

  .--icon {
    background-color: #F4F3F1;
    cursor: pointer;

    img {
      width: 40px;
      filter: invert(60%) sepia(11%) saturate(9%) hue-rotate(111deg) brightness(99%) contrast(90%);
    }
  }

  .--image img,
  .--image video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .--remove {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 16px;
    height: 16px;
    background-color: white;
    border-radius: 100%;
    background-image: url("@/assets/img/svg/cart/plus.svg");
    background-size: 10px;
    background-position: center;
    background-repeat: no-repeat;
    transform: rotate(45deg);
    cursor: pointer;
  }

  .--message {
    color: #989898;
    flex: 1;
  }
}

.form-question__input {
  margin-top: 32px;

  input {
    height: 60px;
  }
}

.form-question__button {
  margin-top: 32px;

  .btn {
    width: 100%;
    height: 60px;
    text-align: center;
    border-radius: 16px;
    font-weight: 600;
  }

  .--message {
    margin-top: 32px;
    text-align: center;
    color: #989898;
    line-height: 120%;
  }
}
.form-question__button_agreement {
  margin-top: 32px;
}
@media (max-width: 1023px) {
  .dialog-create-question {
    .pane {
      padding-right: 2px;
    }
  }
  .dialog-create-question__body {
    padding: 25px 20px;
  }
  .dialog-create-question__title {
    font-size: 20px;
  }
  .dialog-create-question__divider {
    margin: 24px 0;

    &.--hide-mobile {
      display: none;
    }
  }

  .product-card-question {
    border: 0;
    border: none;
  }
  .product-card-question__image {
    max-width: 70px;
    border-radius: 12px;
    margin-right: 16px;
  }
  .product-card-question__name {
    white-space: initial;
    max-width: 215px;
    margin-bottom: 13px;

    font-size: 14px;
  }
  .product-card-question__content {
    padding: 0;
    padding-top: 2px;
  }
  .product-card-question__info {
    margin-top: initial;
    line-height: 100%;

    .--rating {
      img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
  }

  .form-question__rating,
  .form-question__images {
    flex-direction: column;
    align-items: flex-start;

    .--label {
      margin-bottom: 14px;
      font-size: 16px;
    }
  }
  .form-question__comment {
    margin-top: 24px;

    .textarea {
      height: 129px;
      padding: 17px 23px;
      border-radius: 16px;
      font-size: 12px;
    }
  }
  .form-question__images {
    margin-top: 17px;

    .--icon {
      width: 70px;
      height: 70px;
    }

    .--message {
      font-size: 12px;
    }
  }
  .form-question__input {
    input {
      height: 48px;
      border-radius: 16px;
      padding: 0 23px;
      font-size: 12px;
    }
  }
  .form-question__button {
    margin-top: 24px;

    .btn {
      height: 48px;
      border-radius: 12px;
    }
  }
  .form-question__button_agreement {
    margin-top: 24px;
  }

  .modal {
    padding: 20px 0;
  }
  .modal__body {
    border-radius: 24px 24px 0 0;
  }
  .modal__close {
    display: none;
  }
}
</style>
